import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import transformAmount from './filters/transformAmount';

Vue.filter('transformAmount', transformAmount);

Vue.config.productionTip = false;

new Vue({
  created() {
    // catch the install prompt so we can show a toast later
    window.addEventListener('beforeinstallprompt', (prompt) => {
      prompt.preventDefault();
      this.$store.commit('setInstallPrompt', prompt);
    });
    this.$store.dispatch('initializeState').catch((err) => {
      this.$store.commit('addToast', { content: `Could load initial state from database: ${err.message}`, color: 'negative', timeout: 5000 });
    });
  },
  router,
  store,
  render: h => h(App),
}).$mount('#app');
